<template>
  <div :class="['art-btn-wrap', 'relative', 'w-100']">
    
<FormKitLazyProvider config-file="true">
<FormKit
      :model-value="modelValue"
      ref="inputRef"
      :placeholder="placeholder"
      :classes="{
        outer: `art-input w-100 ff-regular ${$attrs.class}`,
        input: '$reset input-style',
        messages: '$reset messages-style-input',
        message: 'message-style-input'
      }"
      :label="label"
      :validation-messages="validationMessages"
      :type="type"
      :id="name"
      :autocomplete="autocomplete"
      :name="name"
      :validation="validation"
      :suffix-icon="suffixIcon"
      :suffix-icon-class="suffixIconClass"
      :floating-label="floatingLabel"
      @blur="$emit('blur')"
      @focus="handleFocus"
      @input="onInput($event)"
      @keyup="$emit('keyup', $event)"
      @keyup.enter="$emit('keyup.enter', $event)"
      @suffix-icon-click="$emit('suffix-icon-click', $event)"
    />
</FormKitLazyProvider>

  </div>
</template>
<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import { onMounted, ref } from 'vue';
import { sendInputSelectedEvent } from '@/resources/tracking';

defineOptions({
  inheritAttrs: false
});

const emit = defineEmits([
  'keyup.enter',
  'keyup',
  'focus',
  'blur',
  'input',
  'update:model-value',
  'suffix-icon-click',
  'focus'
]);
const props = defineProps({
  type: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: false,
    default: ''
  },
  placeholder: {
    type: String,
    required: false,
    default: ''
  },
  suffixIcon: {
    type: String,
    required: false,
    default: null
  },
  suffixIconClass: {
    type: String,
    required: false,
    default: ''
  },
  autocomplete: {
    type: String,
    required: false,
    default: ''
  },
  focus: {
    type: Boolean,
    required: false,
    default: false
  },
  autofocus: {
    type: Boolean,
    required: false,
    default: false
  },
  validation: {
    type: [Object, String],
    default: null
  },
  rules: {
    type: String,
    default: null,
    required: false
  },
  validationMessages: {
    type: String
  },
  mask: {
    type: Boolean,
    default: null
  },
  label: {
    type: String,
    default: null
  },
  floatingLabel: {
    type: Boolean,
    default: true
  },
  value: {
    type: String,
    default: null
  },
  trackingOptions: {
    tye: Object,
    default: {}
  },
  modelValue: {
    type: [String, Number],
    default: ''
  }
});
const inputRef = ref(null);

const onInput = (event: any) => {
  emit('input', event);
  emit('update:model-value', event);

  // Formkit needs pro version to have mask feature
  // therefore, here is an attempt to mimic mask for phone numbers. This will work if prop mask is set to true
  const hasPlusSign = typeof event === 'string' && event?.length && event?.match(/\+/) !== null;
  if (!hasPlusSign && props.mask && inputRef.value.node.value.length) {
    inputRef.value.node.input('+' + event);
  }
};

onMounted(() => {
  if (props.focus) {
    inputRef.value?.focus();
  }
});

function handleFocus() {
  const label = computed(() => (props.trackingOptions?.label ? props.trackingOptions?.label : props.label));
  const value = computed(() => (props.trackingOptions?.value ? props.trackingOptions?.value : props.value));
  sendInputSelectedEvent({ label: label.value, value: value.value?.toString() ?? 'no data' });
  emit('focus');
}
</script>

<style lang="scss" scoped>
.art-input {
  display: block;
  position: relative;
  padding: 0px;
  border-radius: 4px;
  height: 44px !important;
  background: var(--color-input);
  margin-bottom: 34px;
  border: 1px solid var(--color-gray-300);

  &--gray {
    border: 1px solid var(--color-gray-500);
  }

  &:focus-within {
    border: 2px solid var(--color-primary);
  }

  &[data-invalid='true'] {
    border: 2px solid var(--color-error-600);

    .formkit-label {
      color: var(--color-error-600);
    }
  }
}
</style>
